import React, { useState } from "react";
import { Formik, Form } from "formik";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import Routes from "routing/Routes";
import { Button, Row } from "components/bootstrap";
import { FormikInput, InputOptionalInfo, Spinner } from "components/common";
import IndexSetSelect from "components/streams/IndexSetSelect";
import useIndexSetsList from "components/indices/hooks/useIndexSetsList";
import SelectedIndexSetAlert from "components/inputs/InputSetupWizard/steps/components/SelectedIndexSetAlert";
import { ButtonCol, RecommendedTooltip } from "./StepWrapper";
const SubHeadline = styled.h4(
  ({ theme }) => css`
    margin-top: ${theme.spacings.md};
    margin-bottom: ${theme.spacings.xs};
  `
);
const IndexSetInfoText = styled.p(
  ({ theme }) => css`
    margin-top: ${theme.spacings.xs};
    margin-bottom: ${theme.spacings.md};
  `
);
const NewIndexSetButton = styled(Button)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.md};
  `
);
const CreateStreamForm = ({
  submitForm,
  handleBackClick,
  prevCreatedStream = void 0,
  prevShouldCreateNewPipeline = true
}) => {
  var _a, _b, _c, _d, _e;
  const { t } = useTranslation("inputs");
  const [indexSetsRefetchInterval, setIndexSetsRefetchInterval] = useState(false);
  const { data: indexSetsData, isSuccess: isIndexSetsSuccess } = useIndexSetsList(
    false,
    indexSetsRefetchInterval,
    true
  );
  const validate = (values) => {
    let errors = {};
    if (!values.title) {
      errors = { ...errors, title: t("setup_wizard.create_stream.title_required") };
    }
    if (!values.index_set_id) {
      errors = { ...errors, index_set_id: t("setup_wizard.create_stream.index_set_required") };
    }
    return errors;
  };
  const handleNewIndexSetClick = () => {
    window.open(Routes.SYSTEM.INDEX_SETS.CREATE, "_blank");
    setIndexSetsRefetchInterval(1e4);
  };
  if (!isIndexSetsSuccess || !indexSetsData) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const { indexSets } = indexSetsData;
  const initialFormValues = {
    description: (_a = prevCreatedStream == null ? void 0 : prevCreatedStream.description) != null ? _a : void 0,
    title: (_b = prevCreatedStream == null ? void 0 : prevCreatedStream.title) != null ? _b : void 0,
    index_set_id: (_d = prevCreatedStream == null ? void 0 : prevCreatedStream.index_set_id) != null ? _d : (_c = indexSets == null ? void 0 : indexSets.find((indexSet) => indexSet.default)) == null ? void 0 : _c.id,
    remove_matches_from_default_stream: (_e = prevCreatedStream == null ? void 0 : prevCreatedStream.remove_matches_from_default_stream) != null ? _e : true,
    create_new_pipeline: prevShouldCreateNewPipeline
  };
  return /* @__PURE__ */ React.createElement(Formik, { initialValues: initialFormValues, onSubmit: submitForm, validate }, ({ isValid, isValidating, dirty, values }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: t("setup_wizard.create_stream.title"),
      name: "title",
      id: "title",
      help: t("setup_wizard.create_stream.title_help")
    }
  ), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, t("setup_wizard.create_stream.description"), " ", /* @__PURE__ */ React.createElement(InputOptionalInfo, null)),
      name: "description",
      id: "description",
      help: t("setup_wizard.create_stream.description_help")
    }
  ), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, t("setup_wizard.routing.remove_from_default")),
      help: /* @__PURE__ */ React.createElement("span", null, t("setup_wizard.routing.remove_from_default_help")),
      name: "remove_matches_from_default_stream",
      id: "remove_matches_from_default_stream",
      type: "checkbox"
    }
  ), /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      label: /* @__PURE__ */ React.createElement(React.Fragment, null, t("setup_wizard.create_stream.create_pipeline")),
      name: "create_new_pipeline",
      id: "create_new_pipeline",
      type: "checkbox"
    }
  ), /* @__PURE__ */ React.createElement(SubHeadline, null, t("setup_wizard.create_stream.select_index_set")), /* @__PURE__ */ React.createElement(SelectedIndexSetAlert, { indexSets, selectedIndexSetId: values.index_set_id }), /* @__PURE__ */ React.createElement(IndexSetInfoText, null, t("setup_wizard.create_stream.index_set_info"), /* @__PURE__ */ React.createElement("br", null), t("setup_wizard.create_stream.index_set_recommendation")), /* @__PURE__ */ React.createElement(RecommendedTooltip, { opened: true, withArrow: true, position: "right", label: t("setup_wizard.routing.recommended") }, /* @__PURE__ */ React.createElement(NewIndexSetButton, { onClick: handleNewIndexSetClick }, t("setup_wizard.create_stream.create_index_set"))), /* @__PURE__ */ React.createElement(IndexSetSelect, { label: t("setup_wizard.create_stream.select_index_set"), indexSets }), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(ButtonCol, { md: 12 }, /* @__PURE__ */ React.createElement(Button, { onClick: handleBackClick }, t("setup_wizard.back")), /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "primary",
      type: "submit",
      disabled: isValidating || !isValid || !dirty && !prevCreatedStream
    },
    t("common:actions.next")
  )))));
};
export default CreateStreamForm;
